import { FlexContainer, palette } from '@busie/ui-kit'
import { styled } from '@mui/material/styles'

const SidebarToggleStyled = styled(FlexContainer)<{ isOpen: boolean }>(({ isOpen }) => {
  return {
    position: 'fixed',
    top: '50%',
    transform: 'translateY(-50%)',
    left: isOpen ? '421px' : '21px',
    height: '56px',
    width: '32px',
    borderTopRightRadius: '8px',
    borderBottomRightRadius: '8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    background: palette.black.plus85,
    transition: 'all 0.33s',
    boxShadow: '0px 8px 24px rgba(34, 34, 34, 0.15)',
  }
})

export default SidebarToggleStyled
